import React, { useMemo } from 'react'
import { Box, Stack, TableContainer, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import TableView, { useTable } from 'packages/ui/Table'

const ROW_HEIGHT = 48
const VISIBLE_ROWS = 3

export const CheckValue = ({ value }) => (
  <Box component="i" className={`fa-light fa-${value ? 'check' : 'minus'}`} sx={{ fontSize: 12, color: value ? '#92BC62' : '#DCDCDC' }} />
)

const EmptyTable = () => {
  const { t } = useTranslation()

  return (
    <Stack sx={{ height: ROW_HEIGHT * VISIBLE_ROWS }} alignItems="center" justifyContent="center" gap={0.5}>
      <Box component="i" className="fa-light fa-table-list" sx={{ color: '#989898', fontSize: 16 }} />
      <Typography sx={{ color: '#989898', fontSize: 11, fontWeight: 500 }}>
        {t('supervision.hardware.common.no_table_data')}
      </Typography>
    </Stack>
  )
}

export const DetailTable = ({ columns, rows = [] }) => {
  const tableColumns = useMemo(() => columns.map(column => ({
    name: column.key,
    header: { label: () => column.label },
    style: { width: column.width, textAlign: column.align || 'left' },
    value: row => (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: column.align === 'right' ? 'flex-end' : column.align === 'center' ? 'center' : 'flex-start',
          minWidth: 0,
          overflow: 'hidden'
        }}
      >
        {column.render ? column.render(row) : (
          <Typography sx={{ color: '#464646', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {row[column.key] ?? '-'}
          </Typography>
        )}
      </Box>
    )
  })), [columns])
  const apiTable = useTable({ items: rows, columns: tableColumns, rowKey: 'id' })

  return (
    <TableContainer
      sx={{
        flex: 'none',
        width: '100%',
        height: 32 + (ROW_HEIGHT * VISIBLE_ROWS),
        overflow: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        '& .MuiTable-root': { tableLayout: 'fixed', minWidth: 360 },
        '& .MuiTableCell-head': { height: 32, p: '0 12px' },
        '& .MuiTableCell-body': { height: ROW_HEIGHT, p: '0 12px' }
      }}
    >
      <TableView apiTable={apiTable} noItemsMessage={<EmptyTable />} />
    </TableContainer>
  )
}
